import {
  ChakraVStack as VStack,
  ChakraHeading as Heading,
  ChakraList as List,
  ChakraListItem as ListItem,
  ChakraText as Text,
} from "@airhelp/react-ui-components";
import type { SbEditableComponentProps } from "types/storyblok";
import { checkListPadding, CheckListIcons } from "./CheckList.config";
import type { CheckListProps } from "./CheckList.d";

const CheckList = ({
  heading,
  bgColor,
  listItems,
  containerFilling,
  fontSize,
  sbEditable,
}: SbEditableComponentProps<CheckListProps>) => (
  <VStack
    bg={bgColor}
    borderRadius="xl"
    flexDir="column"
    p={checkListPadding[containerFilling]}
    align="left"
    {...sbEditable}
  >
    {heading && (
      <Heading variant="h4" as="h4" fontWeight="normal" mb={4}>
        {heading}
      </Heading>
    )}
    <List>
      {listItems.map(({ text, _uid, iconType }) => {
        const Icon = CheckListIcons[iconType].icon;

        return (
          <ListItem key={_uid} display="flex" alignItems="flex-start" _notLast={{ mb: 6 }}>
            <Icon color={CheckListIcons[iconType].color} boxSize={6} />
            <Text textAlign="left" fontSize={fontSize} ml={4}>
              {text}
            </Text>
          </ListItem>
        );
      })}
    </List>
  </VStack>
);

export default CheckList;
